export function feeGroupMappings(childAccountType: string): string {
  let mapping = {
    'CCP': 'Central Clearing Party',
    'PC': 'Private Client',
    'IB': 'Introducing Broker',
    'PB': 'Full Member',
    'AF': 'Affiliate',
    'Central Clearing Party': 'Central Clearing Party',
    'Private Client': 'Private Client',
    'Introducing Broker': 'Introducing Broker',
    'Full Member': 'Full Member',
    'Affiliate': 'Affiliate',
    'All': 'All'
  }

  return mapping[childAccountType] || ''
}

export function childAccountMappings(feeGroup: string): string {
  let mapping = {
    'Central Clearing Party': 'CCP',
    'Private Client': 'PC',
    'Introducing Broker': 'IB',
    'Full Member': 'PB',
    'Affiliate': 'AF',
    'CCP': 'CCP',
    'PC': 'PC',
    'IB': 'IB',
    'PB': 'PB',
    'AF': 'AF',
    'All': 'All'
  }

  return mapping[feeGroup] || ''
}

export function getChildFeeGroupsFromAccountCategoryId(categoryId: string): string[] {

  switch (categoryId) {
    case AccountCategories.introducingBroker: // IB
      return ['PC']
    case AccountCategories.fullMember: // PB
      return ['PC', 'IB']
    case AccountCategories.centralClearingParty: // CCP
      return ['PB']
    default:
      return []
  }
}



// WEBPACK FOOTER //
// ./ts/components/fees/feeGroupMappings.ts